/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Nda_Required_For_PtInputs */



/**
* | output |
* | --- |
* | "Granting PT requires a signed NDA on record." |
*
* @param {User_Nda_Required_For_PtInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_nda_required_for_pt = /** @type {((inputs?: User_Nda_Required_For_PtInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Nda_Required_For_PtInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'attribution du rôle PT requiert un NDA signé et enregistré.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Otorgar el rol PT requiere un NDA firmado y registrado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conceder o papel PT exige um NDA assinado e registrado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnare il ruolo PT richiede un NDA firmato e registrato.")
	return /** @type {LocalizedString} */ ("Granting PT requires a signed NDA on record.")
});